"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Message_1 = require("../message/Message");
const PosaTemplate_1 = __importDefault(require("./PosaTemplate"));
const prop_types_1 = __importDefault(require("prop-types"));
const RedeemSectionLoggedInStyled_1 = __importDefault(require("./RedeemSectionLoggedInStyled"));
const GiftcardBox_1 = __importDefault(require("./GiftcardBox"));
const UnLoggedInSection = ({ data, getStartAction, loginModal, giftcardConfig }) => {
    const { unLoggedInContent, bgImage, moneyImage } = data;
    const { warningContent } = loginModal;
    const { posaGiftCardCardShow, posaGiftCardRedeemUrl } = giftcardConfig;
    const style = react_1.useMemo(() => ({
        backgroundImage: `url(${bgImage})`
    }), [bgImage]);
    const onClick = react_1.useCallback(() => getStartAction(warningContent), [warningContent]);
    return (react_1.default.createElement(RedeemSectionLoggedInStyled_1.default, { className: "ecr-redeemSection unloggedIn", style: style },
        react_1.default.createElement("div", { className: "ecrrs-left" },
            react_1.default.createElement("img", { src: moneyImage, alt: "card" })),
        react_1.default.createElement("div", { className: "ecrrs-right" },
            react_1.default.createElement("div", { className: "ecrrs-notLoggedIn" },
                react_1.default.createElement(PosaTemplate_1.default, { Tag: "div", isTemplate: true, string: unLoggedInContent }),
                react_1.default.createElement("button", { onClick: onClick }, Message_1.localizedMessage('epic.code.redemption.posa.page.start'))),
            posaGiftCardCardShow && react_1.default.createElement(GiftcardBox_1.default, { showDesc: true, posaGiftCardRedeemUrl: posaGiftCardRedeemUrl }))));
};
UnLoggedInSection.propTypes = {
    data: prop_types_1.default.object,
    getStartAction: prop_types_1.default.func,
    loginModal: prop_types_1.default.object,
    giftcardConfig: prop_types_1.default.object
};
exports.default = UnLoggedInSection;
//# sourceMappingURL=RedeemSectionUnLoggedIn.js.map